export class GetRemoteDatabaseConnectionUrlDto {
    constructor(public ConnectionId: number, public ClientId: string, public ClientSecret: string) {
    }
}